Platform.Deferred.execute(setProductCommonScript);

// Binds the per-item wish list (quote list) heart buttons. Called page-wide at load and re-called
// after AJAX list swaps; pass the swapped container as $scope to bind only the fresh buttons
// (elements outside it, e.g. widget items, keep their original handlers and are not double-bound).
function wishListBtnClickHandler($scope) {
    var $s = $scope || $(document);
    var $modal = $('[data-remodal-id=wishlist-modal]').remodal({
        hashTracking: false
    });
    // favourites handlers
    $s.find('.add-to-wishlist-btn').click(function () {
        $modal.open();
        wishListsChecked = $(this).data("wishlists-checked");
        if (!wishListsChecked)
            wishListsChecked = [];

        CheckWishListCheckboxes(wishListsChecked);

        var $wishListModal = $('.pf-modal-wishlist');
        $wishListModal.find('.container-wishlist').css('width', '');
        $wishListModal.find('.pf-modal-wishlist-image').show();
        // Clear cart-save-mode when opening from normal product flow
        $wishListModal.data('cart-save-mode', false);

        var imgLink = $(this).closest(".pf-product-list-item").find(".pf-list-item-img").attr("src")
            || $(".pf-product-main-image-wrapper").find(".img:first").attr("src");
        $wishListModal.find(".wishlist-picture-img").attr("src", imgLink);
        var id = $(this).data("id");
        $wishListModal.find(".add-to-favorites-btn").data("product-ids", id);
    });

    // Clear cart-save-mode when modal is closed/cancelled. Namespaced + re-bound so repeat calls
    // (this handler runs again after AJAX list swaps) don't stack duplicate document handlers.
    $(document).off('closed.pfWishlistCartSave').on('closed.pfWishlistCartSave', '[data-remodal-id=wishlist-modal]', function () {
        $('.pf-modal-wishlist').data('cart-save-mode', false);
    });
}


function setProductCommonScript() {

    wishListBtnClickHandler();
    var $modal = $('[data-remodal-id=wishlist-modal]').remodal({
        hashTracking: false
    });
    $('.pf-add-all-to-wish-list-btn').click(function () {
        var $productsTarget = $($(this).data('products-target'));
        var productIds = $productsTarget.find('.pf-product-list-item').map(function () {
            return $(this).data('id');
        }).get();

        CheckWishListCheckboxes([]);

        var $wishListModal = $('.pf-modal-wishlist');
        $wishListModal.find('.container-wishlist').css('width', '100%');
        $wishListModal.data('cart-save-mode', false);
        $wishListModal.find(".add-to-favorites-btn").data("product-ids", productIds.join(','));

        $modal.open();
        return false;
    });

    $('.create-wish-List-btn').click(function () {
        $(this).closest(".container-wishlist").find(".pf-wishlist-create-new").removeClass('hidden');
        $(this).closest(".wishlist-main-buttons").addClass('hidden');
        $(".pf-create-wish-list").focus();
    });

    $('.pf-create-wish-list').bind('keypress', function (e) {
        if (e.keyCode == 13) 
            $(".post-new-wishlist-btn").trigger("click");
    });

    $(".post-new-wishlist-btn").click(function () {

        var newListName = $(this).closest(".pf-wishlist-create-new").find(".pf-create-wish-list").val();

        $.post(root + "UserAccount/AddNewWishList", {
            newListName: newListName
        }, function (data) {
            if (data.result == "ok") {
                AddNewWishListCheckbox(data.wishListName, data.wishlistId);
                $(".pf-wishlist-create-new").addClass('hidden');
                $(".wishlist-main-buttons").removeClass('hidden');
                $(".pf-wishlist-create-new").addClass('hidden');
                $(".create-wish-List-btn").css('display', 'inline-block');
                $(".pf-wishlist-create-new").find(".pf-create-wish-list").val("");
            }
            else {
                alert("Error: " + data.error);
            }
        }, "json");
    });
    $(".cancel-new-wishlist-btn").click(function () {
                $(".pf-wishlist-create-new").addClass('hidden');
                $(".wishlist-main-buttons").removeClass('hidden');
                $(".pf-wishlist-create-new").addClass('hidden');
                $(".create-wish-List-btn").css('display', 'inline-block');
    });

    $('.add-to-favorites-btn').click(function () {
        var loggedIn = $('#pf-product-details-page').data("logged-in") || $('.pf-product-list-item').data("logged-in") || ($('.pf-checkout-cart-table').length > 0 ? "True" : null);
        if (loggedIn == "True") {
            var btn = $(this);
            var isVariant = btn.data("is-variant");
            var productIds = btn.data("product-ids").toString().split(',');
            var wishlistIds = [];
            $(this).closest(".container-wishlist").find("input[class ='wishlistCheckbox']:checked").each(function () {
                wishlistIds.push($(this).val());
            });
            var isFav = btn.data("is-fav");
            var optionsAdv = [];
            // check if this is a product with components
            var hasComponents = $('#pf-product-details-page').data('product-has-components');
            if (hasComponents === "True") {
                // check all selected otherwise cannot add to cart
                if (!CheckComponentsSelected()) {
                    alert("Please select from the available product options");
                    return false;
                }
                // if all selected then setup the object to pass into the cart
                optionsAdv = GetSelectedOptionsAdv();
            }

            var previousLists = $(".container-wishlist").data("previousSelectedLists");
            previousLists = eval(previousLists);
            if (wishlistIds.map(Number).sort().join("|") == previousLists.sort().join("|")) {
                alert("No changes detected, please select which quotes you would like updating or cancel. ") /// need to change the wording on this. 
            } else if (!wishlistIds || wishlistIds === [] || wishlistIds.length === 0) {
                if (productIds.length === 1) {
                    $.post(root + "UserAccount/RemoveProductFromFavourites", {
                        id: productIds[0],
                        isVariant: isVariant,
                        optionsAdv: optionsAdv
                    }, function (data) {
                        if (data.result == "ok") {
                            $(document).trigger('removedFromFavs.product.platform', data);

                            ReturnWishlistsCheckedAndSwitchFavIcon(wishlistIds, productIds[0]);

                            $modal.close();
                        }
                        else {
                            alert("Error: " + data.error);
                        }
                    }, "json");
                }
            } else {
                if (productIds.length === 1) {
                    // if any options make sure all have a selection made
                    var prodOptsOk = true;
                    $('.productOptions').each(function () {
                        if ($(this).length > 0) {
                            if ($(this).val() == 0) {
                                $(this).next('.productOptionWarn').fadeIn();
                                $(this).addClass("highlight");
                                prodOptsOk = false;
                                return false;
                            }
                        }
                    });

                    if (prodOptsOk == false) {
                        return false;
                    }

                    var opts = [];
                    $('.productOptions').each(function (i, o) {
                        var opt = {};
                        var name = $(this).attr('id');
                        name = name.replace("option-select-", "");
                        opt.index = i;
                        opt.name = name;
                        opt.value = $(this).val();
                        opts.push(opt);
                    });

                    $.post(root + "UserAccount/AddProductToFavourites", {
                        id: productIds[0],
                        isVariant: isVariant,
                        options: opts,
                        optionsAdv: optionsAdv,
                        wishListIds: wishlistIds
                    }, function (data) {
                        if (data.result == "ok") {
                            $(document).trigger('addedToFavs.product.platform', data);
                            ReturnWishlistsCheckedAndSwitchFavIcon(wishlistIds, productIds[0]);
                            $modal.close();

                            // If triggered from cart "Save to Quote List" button, remove item from cart
                            var $wishListModal = $('.pf-modal-wishlist');
                            if ($wishListModal.data('cart-save-mode')) {
                                var cartItemId = $wishListModal.data('cart-item-id');
                                $wishListModal.data('cart-save-mode', false);
                                $.post(root + 'Cart/RemoveItem', { id: cartItemId }, function (removeData) {
                                    $(document).trigger('itemRemoved.cart.platform', removeData);
                                });
                            }
                        }
                        else {
                            alert("Error: " + data.error);
                        }
                    }, "json");
                } else {
                    $.post(root + "UserAccount/AddProductsToWishLists", {
                        productIds: productIds,
                        wishListIds: wishlistIds
                    }, function (data) {
                        if (data.result === 'ok' || data.result === 'multiple') {
                            $(document).trigger('addedToFavs.product.platform', data);
                            $modal.close();
                        } else {
                            alert("Error: " + data.error);
                        }
                    }, "json");
                }
            }
        }
        else {
            loginModal.open();
        }
    });

}


function ReturnWishlistsCheckedAndSwitchFavIcon(wishListsChecked, productId) {
    var favbutton = $('.add-to-wishlist-btn.isfav-icon[data-id="' + productId + '"]');
    var notFavbutton = $('.add-to-wishlist-btn.isnotfav-icon[data-id="' + productId + '"]');
    var checkedstr = "[" + wishListsChecked.toString() + "]";
    if (wishListsChecked.length == 0) {
        favbutton.addClass('hidden')
        favbutton.data("wishlists-checked", checkedstr);
        notFavbutton.removeClass('hidden')
        notFavbutton.data("wishlists-checked", checkedstr);
    } else {
        favbutton.removeClass('hidden')
        favbutton.data("wishlists-checked", checkedstr);
        notFavbutton.addClass('hidden')
        notFavbutton.data("wishlists-checked", checkedstr);
    }
}



function CheckWishListCheckboxes(wishListsChecked) {
    
        $.each($("input[class ='wishlistCheckbox']"), function () {
            var id = $(this).val();
            if (wishListsChecked.includes(Number(id))) {
                $(this).prop('checked', true);
            } else {
                $(this).prop('checked', false);
            }
        });
    $(".container-wishlist").data("previousSelectedLists", wishListsChecked);
}


function AddNewWishListCheckbox(wishlistName, wishlistId) {
    if ($(".wishlist-section").length) {
        // on the wishlist page. need to refresh rather than append.
        location.reload();
    } else {
        var newItem = "<div class='checkbox' align='right'><input type='checkbox' id='wishlist" + wishlistId + "' class='wishlistCheckbox' name='wishlist" + wishlistId + "' value='" + wishlistId + "' checked='checked' /><label for= 'wishlist" + wishlistId + "' ><span class='pull-left'>" + wishlistName + "</span></label></div>";
        var inserted = false;
        $(".wishlistCheckboxList .checkbox").each(function () {
            var existingName = $(this).find(".pull-left").text().trim();
            if (wishlistName.localeCompare(existingName, undefined, { sensitivity: 'base' }) < 0) {
                $(this).before(newItem);
                inserted = true;
                return false;
            }
        });
        if (!inserted) {
            $(".wishlistCheckboxList").append(newItem);
        }
    }
}


// currently used for products with components only, once all options have been selected we set the add or remove favs buttons by checking via ajax
function SetFavButtons(optionsAdv) {
    var loggedIn = $('#pf-product-details-page').data('logged-in');
    if (loggedIn === "True") {
        $.post(root + "Products/CheckProductIsFavOptionsAdv", {
            productId: $('#pf-product-details-page').data('product-id'),
            optionsAdv: optionsAdv
        }, function (data) {
            if (data.result === 0) {
                var isFav = data.isFav;
            } else {
                alert("Error: " + data.error);
            }
        }, "json");
    }
}